<template>
  <span>
    <el-tooltip class="item" effect="dark" content="Send invoices by email" placement="top-start">
      <el-button
          id="btn-send-invoices-email"
          type="success"
          plain
          @click="dialogVisible = true"
          size="mini"
      >
        Send invoices by email
      </el-button>
    </el-tooltip>
    <el-dialog
        v-on:open="handleOpen"
        title="Send invoices by email"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        width="20%"
        append-to-body
        class="dialog-with-cols"
    >
      <el-form :model="form" ref="form" label-position="top" size="mini">
        <el-row>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
            <el-form-item label="Select date" prop="date">
               <el-date-picker
                   class="el-dropdown-new drop-sp date-dob"
                   v-model="form.date"
                   format="MM/dd/yyyy"
                   clearable
                   type="date"
                   id="form-date"
                   ref="date"
               ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div id="add-dialog-footer" slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
        <el-button
            type="primary"
            id="form-save-button"
            @click="handleSearch"
            size="mini"
            :disabled="!form.date"
        >
          Send
        </el-button>
        <send-invoice-number/>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import { Message } from 'element-ui';
import constants from '@/utils/constants';
import accountService from '@/api/accountService';
import SendInvoiceNumber from '@/views/admin/settings/components/SendSingleInvoiceEmail';

export default {
  name: 'SendInvoicesEmail',
  components: {
    SendInvoiceNumber
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        date: null
      },
    };
  },
  methods: {
    handleOpen() {
      this.resetForm();
    },
    async handleSearch() {
      Message.closeAll();

      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      accountService.sendInvoicesByEmail(this.form.date)
        .then((response) => {
          this.$message.success(response.message);
        }).finally(() => {
          loading.close();
        });
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.form.date = null;
    },
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#btn-send-invoices-email {
  margin-right: 10px;
}
</style>
